module.exports = __webpack_public_path__ + "img/woodhull_large.5774f0fb.png";